import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { IGoogle2faSecretResponse } from 'core/types/models/google2faType';
import { useDispatch } from 'react-redux';

export const useGoogle2FAEnableQuery = (callBack: () => void) => {
	const dispatch = useDispatch();
	const queryClient = useQueryClient();

	return useMutationHook(
		[endPointUrls.GENERATE2FA_ENABLE],
		(data) => api.post(endPointUrls.GENERATE2FA_ENABLE, data),
		{
			onSuccess: (res: any) => {
				if (res?.status === 200) {
					callBack();
					queryClient.invalidateQueries([endPointUrls.PROFILE_MANAGEMENT]);
					toastHandler('success', res?.data.message);
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult<IGoogle2faSecretResponse, Error>;
};
